import _ from 'lodash';
import { useContext, useEffect, useMemo, useState } from 'react';
import { uniqueKey } from '../../../../global/common/keys';
import UiSaveButtons from '../../../../global/components/buttons/UiSaveButtons';
import UpDownLabel from '../../../../global/components/forms/elements/UpDownLabel';
import { gEnums } from '../../../../global/enums/globalEnums';
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper';
import WrapperVertCols from '../../../../global/wrappers/WrapperVertCols';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { seasonalUpdateTypes } from '../../cnr/reducers/reducerHelpers/seasonalDataHelpers';
import SeasonDetailsForm, { _seasonFormTypes } from './SeasonDetailsForm';
import { useCreateSportsSeason } from 'projectSpecific/sports/useHelpers/useCreateSeasonal';
import { useCreateSeasonData } from 'projectSpecific/sports/useHelpers/useCreateSeasonData';
import { _allowUpdate_local } from 'projectSpecific/sports/useHelpers/useSeasonals';
import { key } from 'localforage';

const SportsSeasonDetails = ({ subActionType }) => {

  const _asat = gEnums.availableSubActionTypes

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info: currentSeason_info_season, details_info } = sportsSeason_state ?? {}
  const { details: details_sport, playoffQualifyCounts: playoffQualifyCounts_sport } = details_info ?? {}
  const { currentSeason } = currentSeason_info_season ?? {}

  const _seasonalKey = 'asdf'

  const { update_seasonalData } = useCreateSeasonData()
  const { getSportsSeason, getCreateSportsSeason, ammendSeasonalItem } = useCreateSportsSeason()

  const { seasonals: seasonals_sport } = getSportsSeason()

  const { sportsData_info, currentSeason_info, sportsSeason_selected, selectedItems } = getCreateSportsSeason()
  const { sportPermissions } = sportsData_info ?? {}
  const { seasonals: seasonals_create } = sportsSeason_selected ?? {}
  const { details: details_create, playoffQualifyCounts: playoffQualifyCounts_create } = seasonals_create ?? {}
  const { year } = selectedItems ?? {}
  const { latestSeason } = currentSeason_info ?? {}

  const allowUpdate = _allowUpdate_local && sportPermissions?.any && sportPermissions?.details

  let _year;

  switch (subActionType) {
    case _asat.editSeasonDetails:
      _year = currentSeason
      break;
    default:
      _year = latestSeason
  }

  const [currentSeasonals, setCurrentSeasonals] = useState(seasonals_create || seasonals_sport)
  const [playoffQualifyCounts, setPlayoffQualifyCounts] = useState(playoffQualifyCounts_create || playoffQualifyCounts_sport)

  const handleUpdateSeasonalDB = () => {
    const cbu = () => { }
    const _opts_m = { _details: details_create }
    update_seasonalData({ _seasonalKey, updateType: seasonalUpdateTypes.details, opts: _opts_m, callback: cbu })
  }


  const handleUpdateSeasonalData = ({ key, data }) => {
    switch (subActionType) {
      case _asat.editSeasonDetails:
        const _currentSeasonals = _.cloneDeep(currentSeasonals)
        _.set(_currentSeasonals, key, data)  // safe even for nested paths
        setCurrentSeasonals(_currentSeasonals)
        break;
      default:
        ammendSeasonalItem({ key, data })
    }
  }


  const handleUpDown_qualify = (propKey, value) => {

    const _playoffQualifyCounts = _.cloneDeep(playoffQualifyCounts)
    _playoffQualifyCounts[propKey] = value ? value : 0
    setPlayoffQualifyCounts(_playoffQualifyCounts)

    switch (subActionType) {
      case _asat.editSeasonDetails:
        const _currentSeasonals = _.cloneDeep(currentSeasonals)
        _.set(_currentSeasonals, 'playoffQualifyCounts', _playoffQualifyCounts)  // safe even for nested paths
        setCurrentSeasonals(_currentSeasonals)
        break;
      default:
        switch (subActionType) {
          case _asat.createSeason:
            ammendSeasonalItem({ key: 'playoffQualifyCounts', data: _playoffQualifyCounts })
            break;
          default:
            ammendSeasonalItem({ key: 'playoffQualifyCounts', data: _playoffQualifyCounts })
        }
    }

  }

  const menu_qualify = useMemo(() => {
    const items = _.map(playoffQualifyCounts, (sl, slKey) => {
      return <UpDownLabel
        propKey={slKey}
        formData={playoffQualifyCounts}
        handleChange={handleUpDown_qualify}
        buttonSize={'tiny'} float={'left'} />
    })
    return <div>
      {items}
    </div>
  }, [playoffQualifyCounts])

  const create_form = (seasonFormType) => <SeasonDetailsForm
    key={uniqueKey('cs', 'season')}
    seasonFormType={seasonFormType}
    subActionType={subActionType}
    currentSeasonals={currentSeasonals}
    handleUpdateSeasonalData={handleUpdateSeasonalData}
  />

  const content_formYear = () => <Wrapper
    header={'Current Year'}
    content={create_form(_seasonFormTypes.currentYear)}
    wrapperType={wrapperTypes.padded}
  />

  const content_form_seasonDates = () => <Wrapper
    header={'Season Dates'}
    content={create_form(_seasonFormTypes.seasonStart)}
    wrapperType={wrapperTypes.padded}
  />

  const content_form_qualifyCount = () => <Wrapper
    header={'Playoff Qualify Counts'}
    content={menu_qualify}
    wrapperType={wrapperTypes.padded}
  />

  const content_form_seasonOptions = () => <Wrapper
    header={'Season Options'}
    content={create_form(_seasonFormTypes.currentSeason)}
    wrapperType={wrapperTypes.padded}
  />

  const content_forms = {
    seasonDates: content_form_seasonDates(),
    seasonOptions: content_form_seasonOptions(),
    playoffQualify: content_form_qualifyCount(),
  }

  const _cols = subActionType === _asat.editSeason ? 4 : 3

  const content_season = () => <WrapperVertCols mvc={_cols}>
    {subActionType === _asat.editSeason && content_formYear()}
    {content_forms.seasonDates}
    {content_forms.seasonOptions}
    {content_forms.playoffQualify}
  </WrapperVertCols>

  const wrapper_season = () => <Wrapper
    header={'Details'}
    content={content_season()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper = () => <Wrapper
    header={'Details'}
    content={content_season()}
    footer={<UiSaveButtons save={{ caption: 'Update Seasonal Details (' + _year + ')', oc: handleUpdateSeasonalDB, disabled: !_year, color: allowUpdate ? 'green' : 'teal' }} />}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  switch (subActionType) {
    case _asat.createSeason:
      return wrapper_season()
    default:
      return wrapper()
  }

}

export default SportsSeasonDetails